const dataList: Array<Portfolio> = [

    {
        id: 1,
        image: 'https://artaistry.com/cdn/shop/articles/Clock_Tattoo_5.png?crop=center&height=840&v=1692023644&width=840',
        artistId: 1,
        category: 'Realism',
        info: "The tattoo session was a good piece and blah blah sjkdhksd"
        
    },
    
    {
        id: 2,
        image: 'https://pbs.twimg.com/media/F7xUE0tXQAAQeFt?format=jpg&name=large',
        artistId: 2,
        category: 'Anime',
        info: "verry good"
        
    },
    {
        id: 3,
        image: 'https://otautahitattoo.com/auckland/wp-content/uploads/sites/2/2018/11/custom-maori-tattoo-ta-moko-kirituhi-shoulder-custom-new-zealand-chest-back-otautahi-auckland-jordan-clarke.jpg',
        artistId: 2,
        category: 'Traditional/Old School',
        info: "verry good"
        
    },

    {
        id: 1,
        image: 'https://artaistry.com/cdn/shop/articles/Clock_Tattoo_5.png?crop=center&height=840&v=1692023644&width=840',
        artistId: 1,
        category: 'Real',
        info: "verry good"
        
    },

]

export {dataList};